export type DeviceEnv = 'ios-app' | 'android-app' | 'ios-browser' | 'android-browser' | 'web';
export const getClientEnvironment = (userAgent: string = navigator.userAgent): DeviceEnv => {
  const ua = userAgent || '';

  // Detect Stitch Fix native apps (custom UA markers)
  if (/MobileAppVersion/i.test(ua)) {
    if (/iPad|iPhone|iPod/.test(ua)) return 'ios-app';
    if (/android/i.test(ua)) return 'android-app';
  }

  // Detect browsers on mobile
  if (/android/i.test(ua)) return 'android-browser';
  if (/iPad|iPhone|iPod/.test(ua) && !('MSStream' in window)) return 'ios-browser';

  // Default: desktop web
  return 'web';
};